import { gql } from '../../../__generated__';

export const GET_ALL_FLOOR_PLANS = gql(`
query GetFloorPlansWeb($data: Filter) {
  getFloorPlansWeb(data: $data) {
    data {
      id
      name
      propertyType
      resultScore
      status
      totalScore
      floorNumber
      companyName
      address
      assets {
        angle
        category
        createdAt
        direction
        height
        id
        key
        updatedAt
        width
        xAxis
        yAxis
      }
      createdAt
    }
    total
  }
}
`);

export const COLOR_CODES = gql(`
  query ConfidenceColors {
  getColorCodesWeb {
    confidenceColors {
      high
      low
      medium
    }
    severityColors {
      high
      low
      medium
    }
  }
}`);

export const GET_FLOOR_PLAN_DETECTIONS = gql(`
query GetDetectionsByFloorPlanWeb($data: GetDetectionsByFloorPlanWebInput) {
  getDetectionsByFloorPlanWeb(data: $data) {
    data {
      parentId
      confidence
      createdAt
      description
      detectionImage
      direction
      id
      issue
      resultScore
      severity
      title
      totalScore
      updatedAt
      bbox
      childId
      childType
    }
  }
}
`);

export const DOWNLOAD_FLOOR_PLAN =
  gql(`query DownloadFloorPlanReportWeb($floorPlanId: String) {
  downloadFloorPlanReportWeb(floorPlanId: $floorPlanId) {
    message
    url
  }
}`);
